import * as React from "react";
import { Idevice } from "../../../types/device";
import DeviceContext from "../../../service/indentifyDevice";
import obtradeRowSelection from "../../../service/orderBook/selectAll";
import PositionNoData from "../generic/positionNoData";
import Sort, { eSortState, sort } from "../../../generic/sort";
import PositionTblRowDesk from "./positionTblRowDesk";
import PositionTblRowMob from "./positionTblRowMob";
import PosUtilHdr from "../generic/posUtilHdr";
import EdButton from "../../../generic/edButton";
import ObCheckbox from "../../orderBook/generic/obCheckbox";
import { backButtonValue } from "../../orderBook/obJsXConstants";
import { SearchHighLight } from "../../../service/generic/searchHighlight";
import { HPos2DGroupBy } from "./../../../service/position/positionGroupByHelper";
import { initWS } from "../../../service/edelWebSockets/wsCallbacks";
import { ISocketSubscribeReq, IQuote3Res } from "../../../types/components/edelSockets/edelSocketTypes";
import { edelSocketQuoteReq } from "../../../service/edelWebSockets/wsInit";
import { IPosition } from "../../../types/components/positions/posTypes";
// import _ from "lodash";
import { genHshObj } from "../../../utils/hashObj";

if (DeviceContext().isDesktop) {
	require("../../../../assets/scss/components/toc/position/positionTable/positionTableDsk.scss");
} else if (DeviceContext().isMobile) {
	require("../../../../assets/scss/components/toc/position/positionTable/positionTableMob.scss");
} else {
	require("../../../../assets/scss/components/toc/position/positionTable/positionTableTab.scss");
}

export interface IPositionTblContentProps {
	data: any;
	hideTopSection: (isHidden: boolean) => void;
	updateUnMTM: (retVal: string) => void;
}

const PositionTblContent: React.FC<IPositionTblContentProps> = (props) => {
	const handleDevice: Idevice = DeviceContext();

	//hash object to update stream data;
	//this will be updated every time table data changes
	const streamDtRef = React.useRef<{
		tData: Array<Array<IPosition>>;
		hashObj: { [x: string]: [number, number] };
		rawHshObj: { [x: string]: [number, number] };
	}>({ tData: [], hashObj: {}, rawHshObj: {} });

	// isAccordianOpen = if row is open then it stores rowIndex otherwise -1
	const [isAccordianOpen, setIsAccordianOpen] = React.useState<[number, number]>();
	const [isAllDataSelected, setIsAllDataSelected] = React.useState(false);
	//selected count
	const [selectedCount, setselectedCount] = React.useState<number>(0);
	const [filteredData, setFilteredData] = React.useState<Array<Array<any>>>([]);
	const [tableData, setTableData] = React.useState<Array<Array<any>>>([]);
	const [toggleState, setToggleState] = React.useState(true);

	//selection handle start
	const [isSelectEnable, setIsSelectEnable] = React.useState(false);

	// used to open/close tab
	function toggleTab(groupIndex: number, index: number, e: any) {
		if (
			e &&
			e.nativeEvent &&
			!e.nativeEvent.path.find((m: HTMLElement) => m.className && (m.className.indexOf("check") >= 0 || m.className.indexOf("menu") >= 0))
		) {
			if (isAccordianOpen && isAccordianOpen[0] === groupIndex && isAccordianOpen[1] === index) {
				setIsAccordianOpen(undefined);
			} else {
				setIsAccordianOpen([groupIndex, index]);
			}
		} else if (e === "close") {
			setIsAccordianOpen(undefined);
		}
	}

	const selectRows = (groupIndex: number, index: number) => {
		const retRes = obtradeRowSelection(groupIndex, index, tableData, isAllDataSelected);

		// set the state
		setTableData(retRes.data);
		setselectedCount(retRes.count);

		setIsAllDataSelected(retRes.allSelected);
	};

	// to maintain the state of sorted column
	const [sortedColumnState, setSortedColumnState] = React.useState({ colName: null as string | null, sortState: eSortState.ASC });

	function parsePropData() {
		// adds hdgVl on the first level, just for sorting; DON"T USE IT FOR DATA BINDING
		return props.data
			? props.data.pos.map((row: any) => ({ ...row, name: row.cpName ? row.cpName : row.dpName ? row.dpName : row.trdSym, isSelected: false }))
			: [];
	}

	function getSumOfUnMTM() {
		let unMTM: number = 0;
		tableData.forEach((g: Array<IPosition>) =>
			g.forEach((row: IPosition) => {
				unMTM += +row.urlzPL;
			})
		);

		props.updateUnMTM(unMTM.toFixed(2));
	}

	//calculate unrelaized MTM
	function calcUnMTM(dp: IPosition, ltp: string) {
		if (dp.ltp !== ltp) {
			dp.ltp = ltp;
			let unMTM = +dp.urlzPL;
			//BUY trade
			if (dp.trsTyp === "B") {
				unMTM = (+ltp - +dp.avgByPrc) * +dp.ntByQty;
			}
			//SELL Trade
			if (dp.trsTyp === "S") {
				unMTM = (+ltp - +dp.avgSlPrc) * +dp.ntSlQty;
			}

			dp.urlzPL = unMTM.toFixed(2);
			dp.mtm = (+dp.rlzPL + +unMTM).toString();
		}
		return dp;
	}

	//streamer callback method
	const socketMessages = (message: any, type: string) => {
		if (type === "message") {
			const msgJson = JSON.parse(message) as IQuote3Res,
				resData = msgJson.response.data;
			let tData: Array<Array<IPosition>> = streamDtRef.current.tData;
			const getIndex: [number, number] = streamDtRef.current.hashObj[resData.z3],
				getSrcDtHsh: [number, number] = streamDtRef.current.rawHshObj[resData.z3];
			if (props.data.pos.length) {
				//has to use findIndex to update raw data beacuse this raw data used to search and filter the table data
				// const getPropDataIndex: number = _.findIndex(props.data.pos, { sym: msgJson.response.data.z3 });
				if (getSrcDtHsh[1] >= 0) {
					const selDp: IPosition = props.data.pos[getSrcDtHsh[1]] || {};
					//if compare new and existing value, update if there is a change in value
					if (selDp.ltp !== resData.a9) props.data.pos[getSrcDtHsh[1]] = calcUnMTM(selDp, resData.a9);
				}
				if (getIndex) {
					const gInd = getIndex[0], //group index
						ind = getIndex[1]; //row index in a group
					//if row is indentified update the table data with new value if there is a change in value
					if (gInd >= 0 && ind >= 0 && tData[gInd][ind].ltp !== resData.a9) {
						// tData[gInd][ind].ltp = resData.a9;
						tData[gInd][ind] = calcUnMTM(tData[gInd][ind], resData.a9);

						setFilteredData([...tData]);
						setTableData([...tData]);
					}
				}
			}
		}
	};

	const symbols: Array<{ symbol: string }> = [];

	React.useEffect(() => {
		//groups data based on open and closed postion
		const parseData = parsePropData();
		let data = toggleState ? HPos2DGroupBy(parseData) : [parseData];
		setFilteredData(data);
		setTableData(data);

		//streaming changes
		//stream only if there exist open postions
		if (props.data.pos.find((row: any) => row.sqOff === "true")) {
			props.data.pos.forEach((row: IPosition) => {
				symbols.push({ symbol: row.sym });
			});
			streamDtRef.current.rawHshObj = genHshObj([props.data.pos], "sym"); //hashtable from raw data
			initWS<ISocketSubscribeReq>(
				edelSocketQuoteReq("quote3", {
					vendID: "EDEL",
					vendToken: "",
					userID: "",
					accType: "",
					symbols
				}),
				socketMessages
			);
		}
		return () => {
			//unsubscribe from the streamer to stop receving messages for the requested symbols
			if (props.data.pos.find((row: any) => row.sqOff === "true")) {
				initWS<ISocketSubscribeReq>(
					edelSocketQuoteReq(
						"quote3",
						{
							vendID: "EDEL",
							vendToken: "",
							userID: "",
							accType: "",
							symbols
						},
						"unsubscribe"
					),
					socketMessages
				);
			}
		};
	}, [props.data]);

	React.useEffect(() => {
		streamDtRef.current.hashObj = genHshObj(tableData, "sym");
		streamDtRef.current.tData = tableData;
		getSumOfUnMTM();
	}, [tableData]);

	function onSort(data: Array<Array<any>>, sortState: eSortState, colName: string) {
		setSortedColumnState({ colName, sortState });
		setTableData(data);
	}

	function sortAfterFilter(groupedData: Array<Array<any>>) {
		if (sortedColumnState.colName) {
			const copyGroupedData = groupedData.map((group) => group.map((d) => d));
			sort(copyGroupedData, sortedColumnState.sortState, sortedColumnState.colName, onSort);
			groupedData = copyGroupedData;
		}
	}

	function onDataFilter(data: Array<Array<any>>, sText: string = "", type?: string) {
		setFilteredData(data);

		//highlightes the search text
		if (sText) {
			const SearchText: string = sText.toLowerCase();
			data[0].forEach((row: any) => {
				row.name = SearchHighLight(row.name, SearchText);
			});
		}

		if (type === "search" && toggleState) {
			data = HPos2DGroupBy(data[0]);
		}

		// remove all empty sub arrays
		data = data.filter((d) => d.length);
		setTableData(data);
		sortAfterFilter(data);
	}

	return (
		<div className={!handleDevice.isMobile ? "pos_tbl_wrap" : "pos_mob_tbl_wrap"}>
			<div className="total_pos">
				{!isSelectEnable && (
					<PosUtilHdr
						leftSideText={
							<>
								{/* only for desktop and tablet */}
								{/* postions status - open / closed */}
								{(handleDevice.isDesktop || handleDevice.isTablet) && (
									<div>
										<span className="pos_sts">
											Total Positions:
											{/* <span className="pos_val">{props.data ? props.data.pos.length : 0}</span> */}
											<span className="pos_val">{props.data ? props.data.npos : "--"}</span>
										</span>
										<span className="pos_sts">
											Open:
											{/* <span className="pos_val">{props.data ? props.data.pos.filter((row: any) => row.ntQty !== "0").length : 0}</span> */}
											<span className="pos_val">{props.data ? props.data.opn : "--"}</span>
										</span>
										<span className="pos_sts">
											Closed:
											{/* <span className="pos_val">{props.data ? props.data.pos.filter((row: any) => row.ntQty === "0").length : 0}</span> */}
											<span className="pos_val">{props.data ? props.data.cls : "--"}</span>
										</span>
									</div>
								)}
								{/* only for mobile */}
								{handleDevice.isMobile && (
									<span className="pos_sts">
										Total Positions:
										<span className="pos_val">{props.data ? props.data.pos.length : 0}</span>
									</span>
								)}
							</>
						}
						data={[parsePropData()]}
						searchKey="name"
						onDataFilter={onDataFilter}
						onFilterClick={() => {}}
						onSearchClick={props.hideTopSection}
						onSelectClick={
							tableData.find((g: any) => g.find((row: any) => row.sqOff === "true"))
								? () => {
										setIsSelectEnable(true);
										props.hideTopSection(true);
								  }
								: undefined
						}
						onToggleClick={setToggleState}
					/>
				)}
				{isSelectEnable &&
					(!handleDevice.isMobile ? (
						<div className="util_cont util_select by2 mg-b30">
							<div className="vMid">
								<p className="selectedCount">{selectedCount} selected</p>
							</div>
							<div className="vMid taRight">
								<EdButton
									type="button"
									btnTyp="primary"
									value="Square-off"
									slim={true}
									className="sqr_btn"
									disabled={selectedCount === 0 ? true : false}
									onClick={() => {
										setIsSelectEnable(true);
										props.hideTopSection(true);
									}}
								/>
								<button
									onClick={() => {
										setIsSelectEnable(false);
										props.hideTopSection(false);
									}}
									className="mg-l15 clsBtn edBtn"
								>
									Close
								</button>
							</div>
						</div>
					) : (
						<div>
							<EdButton
								value={backButtonValue}
								btnTyp="link"
								onClick={() => {
									setIsSelectEnable(false);
									props.hideTopSection(false);
								}}
								className="icon_button"
							/>
						</div>
					))}
			</div>

			<div className="pos_table">
				{/* ob position Header Row */}
				{!handleDevice.isMobile && (
					<ul className="hdr_row">
						<li>
							{isSelectEnable && (
								<div className="col chkbx">
									<ObCheckbox name="eqTradeSelect" checked={isAllDataSelected} onChange={() => selectRows(-1, -1)} />
								</div>
							)}
							<div className="col symb"> </div>
							<div className="col ltp">
								<Sort sortList={filteredData} sortedColName={sortedColumnState.colName} sortKey="ltp" onSort={onSort} colName="LTP" />
							</div>
							<div className="col prod_typ">Prod. Type</div>
							<div className="col net_qty taRight">
								<Sort
									sortList={filteredData}
									sortedColName={sortedColumnState.colName}
									sortKey="ntQty"
									onSort={onSort}
									colName="Net Qty"
								/>
							</div>
							<div className="col unrlzd taRight">
								<Sort
									sortList={filteredData}
									sortedColName={sortedColumnState.colName}
									sortKey="urlzPL"
									onSort={onSort}
									colName="Unrealized MTM"
								/>
							</div>
							<div className="col ttl_mtm taRight">
								<Sort
									sortList={filteredData}
									sortedColName={sortedColumnState.colName}
									sortKey="mtm"
									onSort={onSort}
									colName="Total MTM"
								/>
							</div>
							<div className="col opn_tag"></div>
							{!isSelectEnable && (
								<>
									<div className="col sq_off"></div>
									<div className="col add"></div>
									<div className="col menu"></div>
								</>
							)}
						</li>
					</ul>
				)}
				{/* ob position Header Row */}
				{handleDevice.isMobile && (
					<>
						{isSelectEnable && (
							<div className="col chkbx select_check_all">
								<ObCheckbox name="eqTradeSelect" checked={isAllDataSelected} onChange={() => selectRows(-1, -1)}>
									Select All
								</ObCheckbox>
							</div>
						)}
					</>
				)}
				<div className={"position_scroll_cont" + (isAccordianOpen ? " active" : "")}>
					{tableData.length ? (
						tableData.map((group, groupIndex) => (
							<ul className="pos_data ins_data" key={groupIndex}>
								{group.map((row, index) => (
									<React.Fragment key={index}>
										{!handleDevice.isMobile ? (
											<PositionTblRowDesk
												data={row}
												isSelectEnable={isSelectEnable}
												isAccordianOpen={
													!!(isAccordianOpen && isAccordianOpen[0] === groupIndex && isAccordianOpen[1] === index)
												}
												toggleTab={(e) => toggleTab(groupIndex, index, e)}
												onSelect={() => {
													selectRows(groupIndex, index);
												}}
											/>
										) : (
											<PositionTblRowMob
												data={row}
												isSelectEnable={isSelectEnable}
												isAccordianOpen={
													!!(isAccordianOpen && isAccordianOpen[0] === groupIndex && isAccordianOpen[1] === index)
												}
												toggleTab={(e) => toggleTab(groupIndex, index, e)}
												onSelect={() => {
													selectRows(groupIndex, index);
												}}
											/>
										)}
									</React.Fragment>
								))}
							</ul>
						))
					) : (
						<ul className="pos_data ins_data">
							<PositionNoData data={[parsePropData()]} callBackMeth={onDataFilter} showClrBtn={!!parsePropData().length} />
						</ul>
					)}
				</div>
			</div>
		</div>
	);
};

export default PositionTblContent;
